(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mm-cart-page"]) return;
  try {
    
(function(){
  const key = 'mm-cart-removal-pending';
  const section = document.getElementById('mm-cart-page');
  if (!section) return;
  if (sessionStorage.getItem(key)) {
    sessionStorage.removeItem(key);
    if (section.querySelector('.mm-cart-empty')) {
      window.location.replace(section.dataset.root || '/');
      return;
    }
  }
  document.addEventListener('click', function(event){
    if (event.target.closest('#mm-cart-page .mm-cart-remove')) sessionStorage.setItem(key, '1');
  });
  document.addEventListener('submit', function(event){
    if (event.target.id === 'mm-cart-form' && event.submitter?.name === 'update') sessionStorage.setItem(key, '1');
  });
})();

document.addEventListener('click', function(event) {
  const button = event.target.closest('#mm-cart-page [data-step]');
  if (!button) return;
  const input = button.parentElement.querySelector('input');
  input.value = Math.max(0, (parseInt(input.value, 10) || 0) + Number(button.dataset.step));
  document.getElementById('mm-cart-form').requestSubmit(document.getElementById('mm-cart-update'));
});
document.addEventListener('change', function(event) {
  if (!event.target.matches('#mm-cart-page input[name="updates[]"]')) return;
  event.target.value = Math.max(0, parseInt(event.target.value, 10) || 0);
  document.getElementById('mm-cart-form').requestSubmit(document.getElementById('mm-cart-update'));
});
document.addEventListener('click', async function(event) {
  if (!event.target.closest('#mm-cart-apply')) return;
  const section = document.getElementById('mm-cart-page');
  const input = document.getElementById('mm-cart-discount');
  const button = document.getElementById('mm-cart-apply');
  const message = document.getElementById('mm-cart-message');
  if (!input.value.trim()) return;
  button.disabled = true;
  message.textContent = '';
  try {
    const response = await fetch(section.dataset.root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: input.value.trim() }) });
    const cart = await response.json();
    if (!response.ok || (cart.discount_codes && cart.discount_codes.some(code => !code.applicable))) throw new Error(section.dataset.error);
    location.reload();
  } catch (error) {
    message.textContent = section.dataset.error;
    button.disabled = false;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-community-bewerbung"] && !Shopify.designMode) return;
  try {
    
function mmPrepareCommunityForms(){
document.querySelectorAll('.mm-community-application .formful__form').forEach(form=>{
if(form.dataset.mmPrepared)return;
form.dataset.mmPrepared='true';
const thanks=form.parentElement.querySelector('.formful__thanks-message');
if(thanks)new MutationObserver(()=>{if(thanks.classList.contains('formful__show')){thanks.tabIndex=-1;thanks.focus();thanks.scrollIntoView({block:'center',behavior:'smooth'});}}).observe(thanks,{attributes:true,attributeFilter:['class']});
const input=form.querySelector('input[type="file"]');
if(!input)return;
input.accept='image/*';
const zone=input.closest('.formful__dropzone');
const hint=zone.querySelector('.formful__dropzone-text');
if(hint)hint.textContent=form.closest('[data-mm-application]').dataset.uploadHint;
const error=document.createElement('p');
error.className='formful__error';
error.setAttribute('role','alert');
zone.after(error);
form.querySelectorAll('select option[value=""]').forEach(option=>{option.textContent=form.closest('[data-mm-application]').dataset.selectLabel;});
function validateImages(){
const count=zone.querySelector('.formful__dropzone-file-list').children.length;
error.textContent=count>10?form.closest('[data-mm-application]').dataset.imageLimit:'';
return count<=10;
}
new MutationObserver(validateImages).observe(zone.querySelector('.formful__dropzone-file-list'),{childList:true});
form.addEventListener('submit',event=>{
if(!validateImages()){event.preventDefault();event.stopImmediatePropagation();input.focus();}
},true);
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mmPrepareCommunityForms);else mmPrepareCommunityForms();
document.addEventListener('shopify:section:load',mmPrepareCommunityForms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-instagram-static"] && !Shopify.designMode) return;
  try {
    
function initMMInstagram() {
  document.querySelectorAll('.mm-ig').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const modal = root.querySelector('dialog');
    const large = modal.querySelector('video');
    const grid = root.querySelector('.mm-ig-grid');
    const template = root.querySelector('.mm-ig-pool');
    const cards = Array.from(template.content.querySelectorAll('.mm-ig-post'));
    const storageKey = 'mm-instagram-selection-' + root.dataset.sectionId;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let opener;
    let detailQueue = [];
    const videos = () => Array.from(grid.querySelectorAll('video'));
    const play = video => {
      video.muted = true;
      const promise = video.play();
      if (promise) promise.catch(() => {});
    };
    const shuffle = list => {
      for (let i = list.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [list[i], list[j]] = [list[j], list[i]];
      }
      return list;
    };
    const resume = () => {
      if (document.hidden) return;
      if (modal.open) play(large);
      else if (!reduced.matches) videos().filter(video => !finished.has(video.parentElement)).forEach(play);
    };
    const finished = new Set();
    let available = [];
    const showCard = (button, card) => {
      const oldVideo = button.querySelector('video');
      if (oldVideo) oldVideo.pause();
      const video = card.querySelector('video').cloneNode(true);
      video.removeAttribute('autoplay');
      video.removeAttribute('loop');
      video.loop = false;
      button.dataset.full = card.dataset.full;
      button.setAttribute('aria-label', card.getAttribute('aria-label'));
      button.replaceChildren(video);
      video.addEventListener('ended', () => advance(button));
      if (button.isConnected && !document.hidden && !modal.open && !reduced.matches) play(video);
    };
    const advance = button => {
      finished.add(button);
      const active = new Set(Array.from(grid.querySelectorAll('.mm-ig-post')).map(post => post.dataset.full));
      if (!available.some(card => !active.has(card.dataset.full))) available = shuffle([...cards]);
      Array.from(finished).forEach(slot => {
        const occupied = new Set(Array.from(grid.querySelectorAll('.mm-ig-post')).map(post => post.dataset.full));
        const index = available.findIndex(card => !occupied.has(card.dataset.full));
        if (index < 0) return;
        const next = available.splice(index, 1)[0];
        finished.delete(slot);
        showCard(slot, next);
      });
      if (finished.size > 1) {
        const slots = shuffle(Array.from(finished));
        const endedCards = slots.map(slot => cards.find(card => card.dataset.full === slot.dataset.full));
        slots.forEach((slot, index) => {
          finished.delete(slot);
          showCard(slot, endedCards[(index + 1) % slots.length]);
        });
      }
    };
    let recentOrders = [];
    const historyKey = storageKey + '-history';
    const select = () => {
      try {
        const saved = JSON.parse(localStorage.getItem(historyKey) || 'null');
        if (Array.isArray(saved)) recentOrders = saved.filter(order => Array.isArray(order) && order.every(url => typeof url === 'string')).slice(0, 3);
        else {
          const previous = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
          if (Array.isArray(previous) && previous.length) recentOrders = [previous];
        }
      } catch {}
      videos().forEach(video => video.pause());
      finished.clear();
      const pool = shuffle([...cards]).slice(0, 6);
      const previous = recentOrders[0] || [];
      const previousPairs = new Set(previous.slice(1).map((url, index) => [previous[index], url].sort().join('|')));
      let selected = pool;
      let bestScore = Infinity;
      let ties = 0;
      const choose = (order, remaining) => {
        if (remaining.length) {
          remaining.forEach((card, index) => choose([...order, card], remaining.filter((_, other) => other !== index)));
          return;
        }
        let score = 0;
        order.forEach((card, index) => {
          if (card.dataset.full === previous[index]) score += 10000;
          const oldIndex = previous.indexOf(card.dataset.full);
          if (oldIndex >= 0 && Math.abs(oldIndex - index) === 1) score += 5;
          recentOrders.slice(1).forEach((older, age) => {
            if (older[index] === card.dataset.full) score += 4 - age;
          });
          if (index && previousPairs.has([order[index - 1].dataset.full, card.dataset.full].sort().join('|'))) score += 40;
        });
        if (score < bestScore) {
          bestScore = score;
          selected = order;
          ties = 1;
        } else if (score === bestScore && Math.random() < 1 / ++ties) selected = order;
      };
      choose([], pool);
      grid.replaceChildren(...selected.map(card => {
        const clone = card.cloneNode(true);
        showCard(clone, card);
        return clone;
      }));
      const current = selected.map(card => card.dataset.full);
      available = shuffle(cards.filter(card => !current.includes(card.dataset.full)));
      recentOrders = [current, ...recentOrders].slice(0, 3);
      try { localStorage.setItem(historyKey, JSON.stringify(recentOrders)); } catch {}
      try { sessionStorage.setItem(storageKey, JSON.stringify(current)); } catch {}
      resume();
    };
    select();
    grid.addEventListener('click', event => {
      const button = event.target.closest('.mm-ig-post');
      if (!button) return;
      opener = button;
      videos().forEach(video => video.pause());
      detailQueue = shuffle(cards.filter(card => card.dataset.full !== button.dataset.full));
      large.dataset.full = button.dataset.full;
      large.src = button.dataset.full;
      modal.showModal();
      play(large);
    });
    large.addEventListener('ended', () => {
      if (!modal.open || !opener || !opener.isConnected) return;
      if (!detailQueue.length) detailQueue = shuffle(cards.filter(card => card.dataset.full !== large.dataset.full));
      const next = detailQueue.shift();
      if (!next) return;
      large.dataset.full = next.dataset.full;
      large.src = next.dataset.full;
      play(large);
    });
    modal.querySelector('.mm-ig-close').addEventListener('click', () => modal.close());
    modal.addEventListener('click', event => {
      if (event.target !== modal) return;
      const rect = modal.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) modal.close();
    });
    modal.addEventListener('close', () => {
      large.pause();
      large.removeAttribute('src');
      large.load();
      if (opener && opener.isConnected) opener.focus();
      resume();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) { videos().forEach(video => video.pause()); large.pause(); }
      else resume();
    });
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      if (modal.open) modal.close();
      select();
    });
    reduced.addEventListener('change', () => {
      if (reduced.matches) videos().forEach(video => video.pause());
      else resume();
    });
  });
}
initMMInstagram();
document.addEventListener('shopify:section:load', initMMInstagram);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-product-bundle"] && !Shopify.designMode) return;
  try {
    
function initMMPairings(){
  document.querySelectorAll('.mm-pairing').forEach(root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const texts=JSON.parse(root.querySelector('.mm-pairing-text').textContent);
    const bundles=JSON.parse(root.querySelector('.mm-pairing-bundle').textContent);
    const rows=Array.from(root.querySelectorAll('.mm-pairing-row')).map(el=>({el,check:el.querySelector('input'),select:el.querySelector('select'),variants:JSON.parse(el.querySelector('.mm-pairing-variants').textContent)}));
    const total=root.querySelector('.mm-pairing-total'),button=root.querySelector('.mm-pairing-add'),status=root.querySelector('.mm-pairing-status');
    const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'de-DE',{style:'currency',currency:root.dataset.currency||'EUR'}).format(cents/100);
    const variant=row=>row.variants.find(v=>String(v.id)===(row.select?row.select.value:row.el.querySelector('[data-variant]').dataset.variant));
    const selected=()=>rows.filter(row=>row.check.checked);
    const matchBundle=()=>{
      const options=rows.flatMap(row=>{const v=variant(row);return v.options.filter(o=>o!=='Default Title').filter((o,i)=>new Set(row.variants.map(x=>x.options[i])).size>1);});
      return bundles.find(v=>v.options.length===options.length&&v.options.every((o,i)=>o===options[i]));
    };
    function update(){
      const active=selected(),full=active.length===rows.length;
      let sum=0;
      rows.forEach(row=>{
        const v=variant(row),on=row.check.checked;
        row.el.querySelector('.mm-pairing-item').classList.toggle('is-off',!on);
        if(row.select)row.select.disabled=!on;
        const price=row.el.querySelector('.mm-pairing-price');
        price.querySelector('del').hidden=!full;
        price.querySelector('del').textContent=money(v.price);
        price.querySelector('strong').textContent=money(full?Math.round(v.price*.9):v.price);
        if(on)sum+=v.price;
      });
      const discounted=full?Math.round(sum*.9):sum;
      total.querySelector('del').hidden=!full;
      total.querySelector('del').textContent=money(sum);
      total.querySelector('strong').textContent=money(discounted);
      const b=full?matchBundle():null;
      const available=active.every(r=>variant(r).available);
      button.disabled=!available||(full&&(!b||!b.available||b.price!==discounted));
      status.textContent=!available?texts.unavailable:full&&button.disabled?texts.pending:'';
      button.textContent=texts.add;
    }
    rows.forEach(row=>{row.check.addEventListener('change',update);if(row.select)row.select.addEventListener('change',update);});
    button.addEventListener('click',async()=>{
      if(button.disabled)return;
      button.disabled=true;
      try{
        const active=selected(),full=active.length===rows.length;
        const items=full?[{id:matchBundle().id,quantity:1}]:active.map(row=>({id:variant(row).id,quantity:1}));
        const response=await fetch(texts.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        if(!response.ok)throw new Error(texts.error);
        window.location.assign(texts.cart);
      }catch(e){update();status.textContent=texts.error;}
    });
    update();
  });
}
initMMPairings();
document.addEventListener('shopify:section:load',initMMPairings);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('#sticky-add-to-cart .mm-sticky-step');
  if (!button) return;
  const input = button.parentElement.querySelector('input[name="quantity"]');
  const current = Math.max(1, parseInt(input.value, 10) || 1);
  input.value = Math.max(1, current + Number(button.dataset.step));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
document.addEventListener('change', function(event) {
  if (!event.target.matches('#sticky-add-to-cart input[name="quantity"]')) return;
  event.target.value = Math.max(1, parseInt(event.target.value, 10) || 1);
});

  } catch(e) { console.error(e); }
})();
})();
